const parentPageBreadcrumb = document.querySelectorAll('.is-parent-page');

if (parentPageBreadcrumb.length) {
  parentPageBreadcrumb.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();

      const titleSlug = item.getAttribute('data-title-slug');
      const menuItem = document.querySelector(`.site-header__inner [data-title-slug="${titleSlug}"]`);

      if (menuItem) {
        menuItem.classList.add('is-open-submenu');
        document.body.classList.add('is-open-mega-menu');
      }
    });
  });
}
